import { isDefined } from "@clipboard-health/util-ts";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment } from "@mui/material";
import { TextInput } from "@src/appV2/redesign/components/TextInput";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type CredentialsFormData } from "../api/schema";
import { disabledInputTextSx } from "./shared";

interface UKGReadyTimeclockCredentialsProps {
  register: UseFormRegister<CredentialsFormData>;
  errors: FieldErrors<CredentialsFormData>;
  showPin?: boolean;
  onTogglePinVisibility: () => void;
  externalIdErrorPlaceholder?: string;
}

export function UKGReadyTimeclockCredentials({
  register,
  errors,
  showPin,
  onTogglePinVisibility,
  externalIdErrorPlaceholder,
}: UKGReadyTimeclockCredentialsProps) {
  return (
    <>
      <TextInput
        fullWidth
        label="UKG Ready Employee ID"
        InputLabelProps={{
          shrink: isDefined(externalIdErrorPlaceholder) ? true : undefined,
        }}
        error={Boolean(errors.externalId)}
        sx={isDefined(externalIdErrorPlaceholder) ? disabledInputTextSx : {}}
        helperText={errors.externalId?.message}
        disabled={isDefined(externalIdErrorPlaceholder)}
        placeholder={externalIdErrorPlaceholder}
        {...register("externalId")}
      />
      <TextInput
        fullWidth
        label="Time Clock PIN"
        type={showPin ? "text" : "password"}
        error={Boolean(errors.timeclockPin)}
        helperText={errors.timeclockPin?.message}
        inputProps={{ "data-dd-privacy": "mask" }}
        {...register("timeclockPin")}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle pin visibility"
                edge="end"
                onClick={onTogglePinVisibility}
              >
                {showPin ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}
